/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface LiquidityProvider {
  id?: number;
  active?: boolean;
  name?: string;
  shortName?: string;
  accountId?: number;
  account?: Account;
  participateInPriceProtection?: boolean;
  supportPriceImprovement?: boolean;
  routeOnlyFullOrder?: boolean;
  businessEntity?: LiquidityProvider.BusinessEntityEnum;
}
export namespace LiquidityProvider {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
